import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { guid } from '@/mixins/guid';
import tooltip from '@/mixins/components/tooltip';
import { PAGE_TYPES } from '@/constants';

export default Vue.component('editor-history', {
  template: require('./template.html'),
  name: 'editor-history',
  mixins: [guid],
  components: { tooltip },
  computed: {
    ...mapGetters([
      'history',
      'dragging',
      'currentPage',
      'currentSite',
      'activeDroplet',
    ]),
    pageType() {
      const type = this.currentPage.type;
      const text = PAGE_TYPES.includes(type) ? type : 'Droplet';
      return _.startCase(text);
    },
  },
  props: ['history-items'],
  data() {
    return {
      activeItem: null,
      loading: false,
      showModal: false,
      revertedFrom: null,
    };
  },
  watch: {
    showModal(o) {
      this.$store.dispatch('setGlobalOpenModal', o);
    },
    dragging(isDragging) {
      if (isDragging) {
        this.$store.dispatch('toggleHistory', false);
      }
    },
    activeDroplet(droplet) {
      if (droplet._id) {
        this.$store.dispatch('toggleHistory', false);
      }
    },
  },
  methods: {
    openItemModal(item) {
      this.activeItem = item;
      this.showModal = true;
    },
    async revertPage() {
      this.loading = true;
      const notif = {
        id: this.guid(),
      };
      try {
        const item = this.activeItem;
        let snapshot;
        if (PAGE_TYPES.includes(this.currentPage.type)) {
          snapshot = _.cloneDeep(_.omit(this.currentPage, ['blocks']));
          snapshot.blocks = _.cloneDeep(item.snapshot);
          if (item.counts.pageForms) {
            snapshot.forms = _.clone(item.counts.pageForms);
          }
          if (item.counts.pageDraftForms) {
            snapshot.draftForms = _.clone(item.counts.pageDraftForms);
          }
        } else {
          snapshot = _.cloneDeep(item.snapshot);
        }
        if (item.counts.siteForms) {
          this.$store.dispatch('setGlobalValue', {
            item: this.currentSite,
            key: 'forms',
            value: item.counts.siteForms,
          });
        }
        await this.$store.dispatch('revertPage', snapshot);
        this.$emit('page-save');
        await this.$store.dispatch('setCurrentPage', snapshot);
        this.$store.dispatch('addToHistory', {
          type: 'revert_page',
          meta: {
            snapshotId: item._id,
          },
        });
        this.$store.dispatch('toggleHistory', false);
        notif.type = 'success';
        notif.message = 'Successfully reverted page!';
      } catch (error) {
        this.$log.error(error.message || error);
        notif.type = 'error';
        notif.message = `${error.message || error}. This has been reported.`;
      } finally {
        this.loading = false;
        this.$store.dispatch('addNotification', notif);
        this.activeItem = null;
        this.showModal = false;
      }
    },
    onItemHover(item) {
      if (item.type === 'revert_page' && item.meta && item.meta.snapshotId) {
        this.revertedFrom = item.meta.snapshotId;
      }
    },
    onItemLeave() {
      this.revertedFrom = null;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/history/index.js